const E = Symbol("fieldElementValue");
export {
  E as FIELD_ELEMENT_VALUE
};
